import { useCallback, useContext } from "react";
import contextBabylon from "../../../../../context/index.js";
import addGa4Event from "../../../../../helpers/ga4Event.js";
import useSubmitWithRedirect from "../../../../../hooks/common/searchers/submit/useSubmitWithRedirect.js";
import { buildUrl } from "../utils/url.js";
import useSearcherFlightHotelDefaultValues from "./useSearcherFlightHotelDefaultValues.js";
const useSearcherFlightHotelForm = (props)=>{
    const { config  } = props ?? {};
    const { urlSubmit , params  } = config ?? {};
    const { BaseUrl  } = useContext(contextBabylon);
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    // Form
    const handleOnSubmit = useCallback(async (values)=>{
        addGa4Event({
            event: 'search',
            event_type: 'availability',
            event_detail: 'packages/dynamic/flight-hotel'
        });
        const url = await buildUrl(values, BaseUrl, urlSubmit, params);
        window.location.assign(url);
    }, [
        BaseUrl,
        params,
        urlSubmit
    ]);
    const { onSubmit , isRedirecting , setRedirecting  } = useSubmitWithRedirect(handleOnSubmit);
    return {
        onSubmit,
        isRedirecting,
        defaultValues,
        setRedirecting
    };
};
export default useSearcherFlightHotelForm;

//# sourceMappingURL=useSearcherFlightHotelForm.js.map